module.exports =
  FORM_SUBMITTED: 'FORM_SUBMITTED'
  REG_RESULT: 'REG_RESULT'
  RESET_REG: 'RESET_REG'
  APP_CHANGED: 'APP_CHANGED'
  APP_PASSWORD_CHANGED: 'APP_PASSWORD_CHANGED'
  GOT_NEWS: 'GOT_NEWS'
  GOT_FLASH: 'GOT_FLASH'
  ITEM_ZOOMED: 'ITEM_ZOOMED'
  BRNR_USED: 'BRNR_USED'
  NEWS_FILTERED: 'NEWS_FILTERED'
  NEWS_LOADED: 'NEWS_LOADED'
  GOT_FAQ: 'GOT_FAQ'
  FAQ_FILTERED: 'FAQ_FILTERED'
  GOT_LINKS: 'GOT_LINKS'
  LINKS_FILTERED: 'LINKS_FILTERED'
  FETCHED_LINKS: 'FETCHED_LINKS'
  FETCHED_CONTACTS: 'FETCHED_CONTACTS'
  NEWS_ZOOM_CLOSED: 'NEWS_ZOOM_CLOSED'
  NEWS_SELECT: 'NEWS_SELECT'
  GOT_INBOX: 'GOT_INBOX'
  TICKETS_FILTERED: 'TICKETS_FILTERED'
  SET_CHECKBOX: 'SET_CHECKBOX'
  SET_ALL_VISIBLE_CHECKED: 'SET_ALL_VISIBLE_CHECKED'
  SET_ALL_CHECKED: 'SET_ALL_CHECKED'
  SET_ALL_UNCHECKED: 'SET_ALL_UNCHECKED'
  SET_APP_MODULE: 'SET_APP_MODULE'
  TOGGLE_MENU: 'TOGGLE_MENU'
  TOGGLE_SUB_MENU: 'TOGGLE_SUB_MENU'
  MEDIA_CHANGED: 'MEDIA_CHANGED'
  LOG_IN: 'LOG_IN'
  LOGGED_OUT: 'LOGGED_OUT'
  SHOW_LOADER: 'SHOW_LOADER'
  HIDE_LOADER: 'HIDE_LOADER'
  FORCE_SET_LOADER: 'FORCE_SET_LOADER'
  GOT_FINANCES: 'GOT_FINANCES'
  FETCHED_OFFICE_FINANCES: 'FETCHED_OFFICE_FINANCES'
  BAD_CREDENTIALS: 'BAD_CREDENTIALS'
  AUTH_STATE_CHANGED: 'AUTH_STATE_CHANGED'
  HAS_ERRORS: 'HAS_ERRORS'
  LANG_SET: 'LANG_SET'
  SHOW_UPLOAD_MODAL: 'SHOW_UPLOAD_MODAL'
  HIDE_UPLOAD_MODAL: 'HIDE_UPLOAD_MODAL'
  GO_TO_FILE_FORM: 'GO_TO_FILE_FORM'
  GO_BACK_TO_UPLOAD_TYPE: 'GO_BACK_TO_UPLOAD_TYPE'
  CANCEL_UPLOAD: 'CANCEL_UPLOAD'
  ALLOCATE_FILE: 'ALLOCATE_FILE'
  UN_ALLOCATE_FILE: 'UN_ALLOCATE_FILE'
  ADD_FILES: 'ADD_FILES'
  UPLOAD_FILES: 'UPLOAD_FILES'
  UPLOAD_PROGRESS: 'UPLOAD_PROGRESS'
  START_UPLOAD: 'START_UPLOAD'
  SET_UPLOAD_DICT: 'SET_UPLOAD_DICT'
  SET_GENERAL: 'SET_GENERAL'
  SET_OFFICE_SUB_MODULE: 'SET_OFFICE_SUB_MODULE'
  SET_OFFICE_DATA: 'SET_OFFICE_DATA'
  UPDATE_OFFICE_DATA: 'UPDATE_OFFICE_DATA'
  CHANGE_FILE_DATE: 'CHANGE_FILE_DATE'
  REMOVE_FILE: 'REMOVE_FILE'
  GET_UPLOADS: 'GET_UPLOADS'
  CLIENT_DOC_UPDATE_BEM_COMMENT: 'CLIENT_DOC_UPDATE_BEM_COMMENT'
  CLIENT_FILE_DOC_UPDATE_BEM_COMMENT: 'CLIENT_FILE_DOC_UPDATE_BEM_COMMENT'
  TARIFICATION_DOC_UPDATE_BEM_COMMENT: 'TARIFICATION_DOC_UPDATE_BEM_COMMENT'
  CONTRACT_DOCUMENT_DOC_UPDATE_BEM_COMMENT: 'CONTRACT_DOCUMENT_DOC_UPDATE_BEM_COMMENT'
  CONTRACT_FILE_DOC_UPDATE_BEM_COMMENT: 'CONTRACT_FILE_DOC_UPDATE_BEM_COMMENT'
  CLAIM_DOCUMENT_DOC_UPDATE_BEM_COMMENT: 'CLAIM_DOCUMENT_DOC_UPDATE_BEM_COMMENT'
  CLAIM_FILE_DOC_UPDATE_BEM_COMMENT: 'CLAIM_FILE_DOC_UPDATE_BEM_COMMENT'
  UPDATE_UPLOAD_COMMENT: 'UPDATE_UPLOAD_COMMENT'
  INBOX: 'INBOX'
  OUTBOX: 'OUTBOX'
  AGENDA: 'AGENDA'
  CLIENTS: 'CLIENTS'
  LINKS: 'LINKS'
  PRODUCTION: 'PRODUCTION'
  B2B: 'B2B'
  INSURANCE_COMPANY: 'INSURANCE_COMPANY'
  PVVERZEKERINGENCVBA: 'insuranceCompany2320'
  GENERALIBELGIUM: 'insuranceCompany2321'
  CLAIMS: 'CLAIMS'
  CONTRACTS: 'CONTRACTS'
  PROFILE: 'PROFILE'
  WILLDOC: 'WILLDOC'
  OFFICE: 'OFFICE'
  METRO: 'METRO'
  NOT_FOUND: 'NOT_FOUND'
  SET_EMAIL_DOCUMENT_ID: 'SET_EMAIL_DOCUMENT_ID'
  EMAILDOCUMENT: 'EMAILDOCUMENT'
  NEWS: 'NEWS'
  LOGIN: 'LOGIN'
  FAQ: 'FAQ'
  WEBAPPS: 'WEBAPPS'
  PRIVACY: 'PRIVACY'
  SHOW_CONTACT_MODAL: 'SHOW_CONTACT_MODAL'
  HIDE_CONTACT_MODAL: 'HIDE_CONTACT_MODAL'
  ZOOM_CONTACT: 'ZOOM_CONTACT'
  CLOSE_CONTACT: 'CLOSE_CONTACT'
  CLAIMS: 'CLAIMS'
  SET_CLAIMS_DATA: 'SET_CLAIMS_DATA'
  SET_CLIENTS_DATA: 'SET_CLIENTS_DATA'
  SET_CLIENT_SUB_MODULE: 'SET_CLIENT_SUB_MODULE'
  SET_CLIENT_DATA: 'SET_CLIENT_DATA'
  SET_CLIENT_OPTIONS_DICT: 'SET_CLIENT_OPTIONS_DICT'
  SET_CLIENT_CREATE_CONTRACT_STATE: 'SET_CLIENT_CREATE_CONTRACT_STATE'

  INITIALIZE_CLIENT_PROFILE_FORM: 'INITIALIZE_CLIENT_PROFILE_FORM'
  FETCH_CLIENTS_CLIENT_PROFILE_FORM: 'FETCH_CLIENTS_CLIENT_PROFILE_FORM'
  FETCH_CLIENT_CLIENT_PROFILE_FORM: 'FETCH_CLIENT_CLIENT_PROFILE_FORM'
  TOGGLE_MODAL_CLIENT_PROFILE_FORM: 'TOGGLE_MODAL_CLIENT_PROFILE_FORM'
  TOGGLE_LIST_DEFAULT_CLIENT_PROFILE_FORM: 'TOGGLE_LIST_DEFAULT_CLIENT_PROFILE_FORM'
  CLEAN_CLIENT_PROFILE_FORM: 'CLEAN_CLIENT_PROFILE_FORM'
  SET_PROFILE_FORM_CHECKBOX: 'SET_PROFILE_FORM_CHECKBOX'
  CLEAN_PROFILE_FORM_CHECKBOX: 'CLEAN_PROFILE_FORM_CHECKBOX'
  UPDATE_CLIENT_PROFILE_RESULT: 'UPDATE_CLIENT_PROFILE_RESULT'
  FETCH_RELATION_CLIENT_PROFILE_FORM: 'FETCH_RELATION_CLIENT_PROFILE_FORM'
  SENT_TO_FALSE_CLIENT_PROFILE_FORM: 'SENT_TO_FALSE_CLIENT_PROFILE_FORM'
  CLIENT_LOAD_CLAIMS_EXTRA: 'CLIENT_LOAD_CLAIMS_EXTRA'

  FETCHED_CLIENT_FINANCES: 'FETCHED_CLIENT_FINANCES'
  FILTER_ITEMS: 'FILTER_ITEMS'
  FETCHED_CLIENT_CLAIMS: 'FETCHED_CLIENT_CLAIMS'
  SUBMENU_ITEM_ZOOMED: 'SUBMENU_ITEM_ZOOMED'
  FETCHED_CLIENT_CONTRACT: 'FETCHED_CLIENT_CONTRACT'
  SET_AGENDA_DATA: 'SET_AGENDA_DATA'
  SET_UPLOAD_ID: 'SET_UPLOAD_ID'
  UPLOAD_DONE: 'UPLOAD_DONE'
  UPLOAD_ERROR: 'UPLOAD_ERROR'
  UPLOAD_CLEAR_ERROR: 'UPLOAD_CLEAR_ERROR'
  INBOX_ITEMS_STATUS: 'INBOX_ITEMS_STATUS'

  FETCHED_CLIENT_TARIFICATIONS: 'FETCHED_CLIENT_TARIFICATIONS'
  FETCHED_CLIENT_TARIFICATION_DATA: 'FETCHED_CLIENT_TARIFICATION_DATA'

  SET_UNREAD_CHECKED: 'SET_UNREAD_CHECKED'
  GOT_TRANSLATIONS: 'GOT_TRANSLATIONS'
  SET_UNREAD_NUM: 'SET_UNREAD_NUM'
  SET_ITEM_UNREAD: 'SET_ITEM_UNREAD'

  GOT_OUTBOX: 'GOT_OUTBOX'
  OUTBOX_ITEMS_STATUS: 'OUTBOX_ITEMS_STATUS'
  OUTBOX_ITEM_ZOOMED: 'OUTBOX_ITEM_ZOOMED'
  SET_OUTBOX_SUB_MODULE: 'SET_OUTBOX_SUB_MODULE'
  OUTBOX_SET_FILTERED: 'OUTBOX_SET_FILTERED'

  SET_EMAIL_SENDER_MODULE: 'SET_EMAIL_SENDER_MODULE'
  SHOW_EMAIL_SENDER_MODAL: 'SHOW_EMAIL_SENDER_MODAL'
  HIDE_EMAIL_SENDER_MODAL: 'HIDE_EMAIL_SENDER_MODAL'
  SHOW_EMAIL_SENDER_CONF_MODAL: 'SHOW_EMAIL_SENDER_CONF_MODAL'
  HIDE_EMAIL_SENDER_CONF_MODAL: 'HIDE_EMAIL_SENDER_CONF_MODAL'
  SHOW_EMAIL_SENDER_ATT_MODAL: 'SHOW_EMAIL_SENDER_ATT_MODAL'
  HIDE_EMAIL_SENDER_ATT_MODAL: 'HIDE_EMAIL_SENDER_ATT_MODAL'
  SET_EMAIL_EXTERNAL_ATTACHMENTS: 'SET_EMAIL_EXTERNAL_ATTACHMENTS'
  SHOW_EMAIL_SERVER_CONFIG_MODAL: 'SHOW_EMAIL_SERVER_CONFIG_MODAL'
  HIDE_EMAIL_SERVER_CONFIG_MODAL: 'HIDE_EMAIL_SERVER_CONFIG_MODAL'
  # EMAIL_SENDER_UPDATE_MODULE_OPTIONS: 'EMAIL_SENDER_UPDATE_MODULE_OPTIONS'
  # INIT_EMAIL_SENDER_FORM: 'INIT_EMAIL_SENDER_FORM'

  FETCHED_SIGNATURES: 'FETCHED_SIGNATURES'
  ZOOM_SIGNATURE: 'ZOOM_SIGNATURE'
  CLOSE_SIGNATURE: 'CLOSE_SIGNATURE'

  SET_CLIENT: 'SET_CLIENT'
  SET_FILTER: 'SET_FILTER'
  SET_CONTRACT_DETAILS: 'SET_CONTRACT_DETAILS'
  SET_CLIENT_CLAIMS: 'SET_CLIENT_CLAIMS'
  SET_CLAIM_DETAIL: 'SET_CLAIM_DETAIL'
  SET_FILTERED: 'SET_FILTERED'
  SET_IS_IE: 'SET_IS_IE'
  GOT_WEBAPPS: 'GOT_WEBAPPS'
  GOT_USERS: 'GOT_USERS'
  SET_SUBSCRIBERS: 'SET_SUBSCRIBERS'
  FETCHED_ADMIN_DOCS: 'FETCHED_ADMIN_DOCS'
  SET_ADMIN_DICT: 'SET_ADMIN_DICT'
  COOKIES_ACCEPTED: 'COOKIES_ACCEPTED'
  COOKIES_CLEAN: 'COOKIES_CLEAN'
  NOTIFICATION_SET: 'NOTIFICATION_SET'
  NOTIFICATION_CLEAR: 'NOTIFICATION_CLEAR'
  WEBAPPS: 'WEBAPPS'
  SET_PASSWORD: 'SET_PASSWORD'
  SET_B2B_INSURANCE_COMPANY: 'SET_B2B_INSURANCE_COMPANY'
  SET_B2BCOMPANY_BROKERS_DATA: 'SET_B2BCOMPANY_BROKERS_DATA'
  SET_B2BCOMPANY_SUB_MODULE: 'SET_B2BCOMPANY_SUB_MODULE'
  B2BCOMPANY_BRNR_USED: 'B2BCOMPANY_BRNR_USED'
  SET_B2BCOMPANY_CLIENTS_DATA: 'SET_B2BCOMPANY_CLIENTS_DATA'
  B2BCOMPANY_ITEM_ZOOMED: 'B2BCOMPANY_ITEM_ZOOMED'
  SET_B2BCOMPANY_SELECTED_POLICY: 'SET_B2BCOMPANY_SELECTED_POLICY'
  SHOW_B2BCOMPANY_POLICY_MODAL: 'SHOW_B2BCOMPANY_POLICY_MODAL'
  HIDE_B2BCOMPANY_POLICY_MODAL: 'HIDE_B2BCOMPANY_POLICY_MODAL'
  B2BCOMPANY_GET_ACTIONS: 'B2BCOMPANY_GET_ACTIONS'
  B2BCOMPANY_SWITCH_ACTION: 'B2BCOMPANY_SWITCH_ACTION'
  B2BCOMPANY_FETCHED_POLICIES: 'B2BCOMPANY_FETCHED_POLICIES'
  B2BCOMPANY_CLIENT_ACTION_USED: 'B2BCOMPANY_CLIENT_ACTION_USED'
  B2BCOMPANY_CLIENT_SUB_ACTION_USED: 'B2BCOMPANY_CLIENT_SUB_ACTION_USED'
  B2BCOMPANY_SET_ACTIONS_DICT: 'B2BCOMPANY_SET_ACTIONS_DICT'
  B2BCOMPANY_SET_TRANSACTION_DETAILS: 'B2BCOMPANY_SET_TRANSACTION_DETAILS'
  B2BCOMPANY_SET_COMPANY: 'B2BCOMPANY_SET_COMPANY'
  B2BCOMPANY_SET_TRANSACTIONS: 'B2BCOMPANY_SET_TRANSACTIONS'
  B2BCOMPANY_SEARCH_BY_CONTRACT_NUMBER: 'B2BCOMPANY_SEARCH_BY_CONTRACT_NUMBER'

  TASKLIST: 'TASKLIST'
  TASK_MODULE_LIST_SET: 'TASK_MODULE_LIST_SET',
  TASK_MODULE_LIST_DEFAULT_COLORS_SET: 'TASK_MODULE_LIST_DEFAULT_COLORS_SET'
  TASK_MODULE_LIST_USER_COLORS_SET: 'TASK_MODULE_LIST_USER_COLORS_SET'
  TASK_MODULE_FILTER: 'TASK_MODULE_FILTER'
  TASK_MODULE_FILTER_CLEAN: 'TASK_MODULE_FILTER_CLEAN'
  TASK_MODULE_MODAL_TOGGLE: 'TASK_MODULE_MODAL_TOGGLE'
  TASK_MODULE_MODAL_NOTIFICATION_SET: 'TASK_MODULE_MODAL_NOTIFICATION_SET'
  TASK_MODULE_MODAL_NAME_MANAGE_TASK: 'TASK_MODULE_MODAL_NAME_MANAGE_TASK'
  TASK_MODULE_MODAL_NAME_MANAGE_COLORS: 'TASK_MODULE_MODAL_NAME_MANAGE_COLORS'
  TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER: 'TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER'
  TASK_MODULE_MODAL_NAME_NOTIFICATION: 'TASK_MODULE_MODAL_NAME_NOTIFICATION'
  TASK_MODULE_MODAL_NAME_SEND_TASK: 'TASK_MODULE_MODAL_NAME_SEND_TASK'
  TASK_MODULE_MODAL_NOTIFICATION_RESET: 'TASK_MODULE_MODAL_NOTIFICATION_RESET'
  TASK_MODULE_FORM_ERROR: 'TASK_MODULE_FORM_ERROR'
  TASK_MODULE_FORM_CLEAN: 'TASK_MODULE_FORM_CLEAN'
  TASK_MODULE_FORM_CLEAN_MESSAGE: 'TASK_MODULE_FORM_CLEAN_MESSAGE'
  TASK_MODULE_FORM_EDIT_SET: 'TASK_MODULE_FORM_EDIT_SET'
  TASK_MODULE_ITEM_SET_CHECK: 'TASK_MODULE_ITEM_SET_CHECK'
  TASK_MODULE_ITEM_SET_CHECK_ALL_VISIBLE: 'TASK_MODULE_ITEM_SET_CHECK_ALL_VISIBLE'

  INBOX_ARCHIVE_SET_STAFF_LIST: 'INBOX_ARCHIVE_SET_STAFF_LIST'
  INBOX_ARCHIVE_RESET_STAFF_LIST: 'INBOX_ARCHIVE_RESET_STAFF_LIST'
  INBOX_ARCHIVE_MODAL_TOGGLE: 'INBOX_ARCHIVE_MODAL_TOGGLE'
  INBOX_ARCHIVE_CONVERT_TICKET_SUCCESS: 'INBOX_ARCHIVE_CONVERT_TICKET_SUCCESS'
  INBOX_ARCHIVE_CONVERT_TICKET_ERROR: 'INBOX_ARCHIVE_CONVERT_TICKET_ERROR'
  INBOX_ARCHIVE_CLEAN_SELECTED_ITEMS: 'INBOX_ARCHIVE_CLEAN_SELECTED_ITEMS'
  SET_APP_NOTIFICATIONS: 'SET_APP_NOTIFICATIONS'
  TASK_MODULE_ITEM_READED: 'TASK_MODULE_ITEM_READED'
  GET_CLIENT_ID: 'GET_CLIENT_ID'

  TASK_CREATOR_MODAL_TOGGLE: 'TASK_CREATOR_MODAL_TOGGLE'
  TASK_CREATOR_CONVERTION_SUCCESS: 'TASK_CREATOR_CONVERTION_SUCCESS'
  TASK_CREATOR_CONVERTION_FAIL: 'TASK_CREATOR_CONVERTION_FAIL'

  CONTRACT_PRE_PROPOSAL: 'CONTRACT_PRE_PROPOSAL'
  CONTRACT_PRE_MANDATE: 'CONTRACT_PRE_MANDATE'
  UPLOADER_STATE_NEW_POLICY: 'UPLOADER_STATE_NEW_POLICY'
  UPLOADER_STATE_NEW_POLICY_ID: '17'
  UPLOADER_STATE_POLICY_FILE: 'UPLOADER_STATE_POLICY_FILE'
  UPLOADER_STATE_POLICY_FILE_ID: '2'

  ACCOUNT_CONFIRMATION: 'ACCOUNT_CONFIRMATION'
  SET_ACCOUNT_CONFIRMATION_STEP: 'SET_ACCOUNT_CONFIRMATION_STEP',
  SET_ACCOUNT_CONFIRMATION_HASH: 'SET_ACCOUNT_CONFIRMATION_HASH',
  CLEAN_ACCOUNT_CONFIRMATION: 'CLEAN_ACCOUNT_CONFIRMATION',
  SHOW_PRINT_MODAL: 'SHOW_PRINT_MODAL'
  HIDE_PRINT_MODAL: 'HIDE_PRINT_MODAL'


  DSDOCUMENTS: 'DSDOCUMENTS'
  GOT_DSDOCUMENTS: 'GOT_DSDOCUMENTS'
  GOT_DSDOCUMENT: 'GOT_DSDOCUMENT'
  DSDOCUMENT_ITEMS_STATUS: 'DSDOCUMENT_ITEMS_STATUS'
  DSDOCUMENT_ITEM_ZOOMED: 'DSDOCUMENT_ITEM_ZOOMED'
  DSDOCUMENT_PACKAGE_ZOOMED: 'DSDOCUMENT_PACKAGE_ZOOMED'
  SET_DSDOCUMENT_SUB_MODULE: 'SET_DSDOCUMENT_SUB_MODULE'
  DSDOCUMENT_SET_FILTERED: 'DSDOCUMENT_SET_FILTERED'
  GOT_DS_CONFIG: 'GOT_DS_CONFIG'
  GOT_DSDATASET: 'GOT_DSDATASET'
  GOT_DSDOCUMENT_TEMPLATE: 'GOT_DSDOCUMENT_TEMPLATE'
  GOT_DSPACKAGES: 'GOT_DSPACKAGES'
  GOT_DSDOCS_AND_PACKAGES: 'GOT_DSDOCS_AND_PACKAGES'
  GOT_TEAM_SUBGROUPS: 'GOT_TEAM_SUBGROUPS'
  GOT_PAGINATED_PACKAGES: 'GOT_PAGINATED_PACKAGES'
  RESET_PAGINATED_DATA: 'RESET_PAGINATED_DATA'

#!!! IMPROTANT !!! do not change the constant values, if must then change it in server side proiect also: app/lib/helpers
  DS_INITIALIZED: 'initialized'
  DS_FILLED_BY_BROKER: 'filledByBroker'
  DS_GENERATED: 'generated'
  DS_PACKAGE_CREATED: 'packageCreated'
  DS_DOCUMENTS_UPLOADED_CONNECTIVE: 'documentsUploadedConnective'
  DS_PACKAGE_STATUS_DRAFT: 'packageStatusDraft'
  DS_PACKAGE_STATUS_PENDING: 'packageStatusPending'
  DS_PACKAGE_STATUS_IN_PROGGRESS: 'packageStatusInProgress'
  DS_PACKAGE_STATUS_ENDING: 'packageStatusEnding'
  DS_PACKAGE_STATUS_REJECTED: 'packageStatusRejected'
  DS_PACKAGE_STATUS_REVOKED: 'packageStatusRevoked'
  DS_PACKAGE_STATUS_EXPIRED: 'packageStatusExpired'
  DS_PACKAGE_STATUS_FAILED: 'packageStatusFailed'
  DS_PACKAGE_STATUS_FINISHED: 'packageStatusFinished'
  DS_PACKAGE_STATUS_DELETED: 'packageStatusDeleted'
  DS_DOCUMENTS_DOWNLOADED: 'documentsDownloaded'
  DS_DOCUMENTS_TRANSFERRED_TO_ORACLE: 'documentsTransferredToOracle'
  DS_DOCUMENTS_SENT_A_COPY_FOR_CLIENT: 'emailSentWithSignedDocs'
  DS_DOCUMENTS_ERROR: 'documentError'
  DS_DOCUMENTS_GENERAL_ERROR: 'generalError'

  DS_TEAM_LEVEN: 'LEVEN'
  DS_TEAM_LEVEN_INDEX: '1'

  # the key for get settings from database (key index of the record)
  DIGITAL_SIGNATURE_SETTINGS: 'DIGITAL_SIGNATURE_SETTINGS'

  DSWIZARD_STEP_1_COMPOSE_PACKAGE: 'DSWIZARD_STEP_1_COMPOSE_PACKAGE'
  DSWIZARD_STEP_2_FILL_DOCUMENTS: 'DSWIZARD_STEP_2_FILL_DOCUMENTS'
  DSWIZARD_STEP_3_BROKER_FILLING: 'DSWIZARD_STEP_3_BROKER_FILLING'
  DSWIZARD_STEP_4_SEND_TO_CONNECTIVE: 'DSWIZARD_STEP_4_SEND_TO_CONNECTIVE'
  DSWIZARD_STEP_WAITING: 'DSWIZARD_STEP_WAITING'
  SET_DS_WIZARD: 'SET_DS_WIZARD'
  SET_DS_INVITATION_EDITOR: 'SET_DS_INVITATION_EDITOR'
  SET_DS_INVITATION_EDITOR_FROM_TICKET: 'SET_DS_INVITATION_EDITOR_FROM_TICKET'

  DS_MODULE_CLIENT_PROFILE: 'DS_MODULE_CLIENT_PROFILE'
  DS_MODULE_CLIENT_CONTRACT: 'DS_MODULE_CLIENT_CONTRACT'
  DS_MODULE_CLIENT_CONTRACT_PREM: 'DS_MODULE_CLIENT_CONTRACT_PREM'
  DS_MODULE_CLIENT_CLAIMS: 'DS_MODULE_CLIENT_CLAIMS'
  DS_MODULE_CLIENT_TARIFICATION: 'DS_MODULE_CLIENT_TARIFICATION'
  DS_MODULE_OFFICE: 'DS_MODULE_OFFICE'
  #v10 claimWizard
  DS_MODULE_CLAIM_WIZARD: 'DS_MODULE_CLAIM_WIZARD'
  SET_CLAIM_WIZARD_SUBQUALIFICATION: 'SET_CLAIM_WIZARD_SUBQUALIFICATION'
  
  DSDOC_IFRAME_PRE_REF: 'DSDOC_IFRAME_PRE_REF_'
  DSDOC_PLACEHOLDER_ELEMENT_REF: 'DSDOC_PLACEHOLDER_ELEMENT_REF'

  # used to determine the clyent type by translation got from oracle
  CLIENT_TYPE_PERSON: 'CLIENT_TYPE_PERSON'
  CLIENT_TYPE_COMPANY: 'CLIENT_TYPE_COMPANY'
  DISABLE_BACKGROUND_PROCESSES: 'DISABLE_BACKGROUND_PROCESSES'
  NAVIGATE_TO_DSDOCUMENT: 'NAVIGATE_TO_DSDOCUMENT'

  DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS: 'DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS'
  DSDOCUMENT_EMAIL_CHANGE_PDF_CONNECTIVE_EMAIL_PROCESS: 'DSDOCUMENT_EMAIL_CHANGE_PDF_CONNECTIVE_EMAIL_PROCESS'
  DSDOCUMENT_PHONE_NUMBER_CHANGE_PDF_CONNECTIVE_EMAIL_PROCESS: 'DSDOCUMENT_PHONE_NUMBER_CHANGE_PDF_CONNECTIVE_EMAIL_PROCESS'

  USERS_PROCESS_FLAG_ARRIVED: 'USERS_PROCESS_FLAG_ARRIVED'
  USERS_PROCESS_FLAG_STOP_WATCH: 'USERS_PROCESS_FLAG_STOP_WATCH'
  USERS_PROCESS_FLAG_START_WATCH: 'USERS_PROCESS_FLAG_START_WATCH'
  USERS_PROCESS_FLAG_REMOVE: 'USERS_PROCESS_FLAG_REMOVE'
  USERS_PROCESS_FLAG_DEFAULT: 'USERS_PROCESS_FLAG_DEFAULT'

  VERSION_CHECK_NOTIFICATION_SET: 'VERSION_CHECK_NOTIFICATION_SET'

  CLAIM_DOCUMENTS_TAB: 'CLAIM_DOCUMENTS_TAB'
  CONTRACT_DOCUMENTS_TAB: 'CONTRACT_DOCUMENTS_TAB'
  TARIFICATION_DOCUMENTS_TAB: 'TARIFICATION_DOCUMENTS_TAB'
  PROFILE_DOCUMENTS_TAB: 'PROFILE_DOCUMENTS_TAB'
  TICKET_DOCUMENTS_TAB: 'TICKET_DOCUMENTS_TAB'
  #used for emailer modals to assign them, separately open or close them using by this ids
  EMAILER_MODAL_ID_DSWIZARD_STEP_3: 'EMAILER_MODAL_ID_DSWIZARD_STEP_3'
  EMAILER_MODAL_ID_PACKAGE_DETAILS: 'EMAILER_MODAL_ID_PACKAGE_DETAILS'
  EMAILER_MODAL_ID_PACKAGE_DETAILS_2: 'EMAILER_MODAL_ID_PACKAGE_DETAILS_2'
  EMAILER_MODAL_ID_EDIT_EMAIL_OF_PACAKGE: 'EMAILER_MODAL_ID_EDIT_EMAIL_OF_PACAKGE'
  EMAILER_MODAL_HIDDEN_IN_PACKAGE_DETAILS: 'EMAILER_MODAL_HIDDEN_IN_PACKAGE_DETAILS'
  EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT: 'EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT'

  SET_CLAIM_WIZARD_STEP: 'SET_CLAIM_WIZARD_STEP'
  SET_CLAIM_WIZARD_DATA: 'SET_CLAIM_WIZARD_DATA'
  SET_ALL_CLAIMWIZARD_PACKAGES: 'SET_ALL_CLAIMWIZARD_PACKAGES'
  CLEAR_CLAIM_WIZARD_PACKAGES: 'CLEAR_CLAIM_WIZARD_PACKAGES'
  TOGGLE_LEGAL_AID: 'TOGGLE_LEGAL_AID'
  SET_CLAIM_WIZARD_DOCUMENTATION: 'SET_CLAIM_WIZARD_DOCUMENTATION'
  RESET_CLAIM_WIZARD: 'RESET_CLAIM_WIZARD'
  ADD_OPTIONAL_PARTY: 'ADD_OPTIONAL_PARTY'
  REMOVE_OPTIONAL_PARTY: 'REMOVE_OPTIONAL_PARTY'
  UPDATE_PARTY_FIELD: 'UPDATE_PARTY_FIELD'
  SET_DOCUMENTS_FOR_STEP_THREE: 'SET_DOCUMENTS_FOR_STEP_THREE'
  SET_ALTERNATIVE_DOC_TYPE: 'SET_ALTERNATIVE_DOC_TYPE'
  ADD_OPTIONAL_CLAIM_DOCUMENT: 'ADD_OPTIONAL_CLAIM_DOCUMENT'
  UPDATE_CLAIM_WIZARD_OPTIONAL_DOCUMENT: 'UPDATE_CLAIM_WIZARD_OPTIONAL_DOCUMENT'
  REMOVE_CLAIM_WIZARD_OPTIONAL_DOCUMENT: 'REMOVE_CLAIM_WIZARD_OPTIONAL_DOCUMENT'
  ADD_FILES_TO_CLAIM_WIZARD: 'ADD_FILES_TO_CLAIM_WIZARD'
  REMOVE_DOCUMENT_FILE_FROM_CLAIM_WIZARD: 'REMOVE_DOCUMENT_FILE_FROM_CLAIM_WIZARD'
  UPDATE_FILE_UPLOAD_STATUS: 'UPDATE_FILE_UPLOAD_STATUS'


// WEBPACK FOOTER //
// ./state/constants.coffee